// extracted by mini-css-extract-plugin
module.exports = {"header":"Steps-module__header___3a3Q9","headerAndSubtitle":"Steps-module__headerAndSubtitle___24dvN"};